import axios from '@/utils/request'
const urlPrefix = 'map'

// 上传EXCEL文件
export function upload (params) {
  return axios({
    url: urlPrefix + '/dataSources/excel',
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// http数据源
export function httpApi (params) {
  Object.assign(params, {
    apiConfig: {
      config: params.httpApiConfig,
      id: params.httpApiConfig.id
    }
  })
  delete params.httpApiConfig
  return axios.post(urlPrefix + '/dataSources/api', params)
}
// 获取数据源下拉列表
export function httpApiSelect (params) {
  return axios.get(urlPrefix + '/apiHttpConfigs/findByTeam', {
    params: {
      userFilter: false
    }
  }).then(({ data }) => {
    const temp = data.map(p => {
      const { id, ...config } = p.config
      const t = Object.assign({
        config: {
          // ...config,
          id
        },
        ...config
      }, p)
      return t
    })
    return {
      data: temp
    }
  })
}

// 提交表数据
export function confirm (params) {
  return axios({
    url: urlPrefix + '/data/confirm',
    method: 'POST',
    data: params
  })
}

// 获取数据列表
export function getDataList (params) {
  const dataSource = params.dataSourceTypes.map(val => `dataSourceTypes=${val}`).join('&')
  return axios.get(`${urlPrefix}/dataSources/page?name=${params.name}&pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&${dataSource}`)
  // return axios({
  //   url: urlPrefix + '/dataSources/page',
  //   method: 'GET',
  //   params: params
  // })
}

// 查询数据表详情
export function getDetails (params) {
  return axios({
    url: urlPrefix + '/data/detail',
    method: 'GET',
    params: params
  })
}
// 查询API表详情
export function getApiDetails (params) {
  return axios({
    url: urlPrefix + '/dataSources/api',
    method: 'GET',
    params: params
  }).then(req => {
    const { data } = req
    data.apiHttpConfig = { ...data.apiConfig.config, id: data.id }
    return req
  })
}
// 查询数据表详情v2
export function getDetailsV2 (params) {
  return axios({
    url: urlPrefix + '/dataSources',
    method: 'GET',
    params: params
  })
}

// 获取绑定数据源
export function getBindTable (params) {
  return axios({
    url: urlPrefix + '/data/detail/v2',
    method: 'GET',
    params: params
  })
}

// 查询数据表详情v2
export function getDetailsV3 (params) {
  return axios({
    url: urlPrefix + '/data/detail/v3',
    method: 'GET',
    params: params
  })
}

// 删除表
export function deleteTable (params) {
  return axios({
    url: urlPrefix + '/dataSources',
    method: 'DELETE',
    data: params
  })
}

// 重命名
export function rename (params) {
  return axios({
    url: urlPrefix + '/data/table/rename',
    method: 'PUT',
    data: params
  })
}
// 编辑API表单 和 重命名
export function editApiForm (params) {
  console.log()
  const config = params.httpApiConfig
  return axios({
    url: urlPrefix + '/dataSources',
    method: 'PUT',
    data: {
      ...params,
      apiConfig: config ? ({
        config,
        id: config.id
      }) : undefined
    }
  })
}

// 导出表
export function download (params) {
  return axios({
    url: urlPrefix + '/data/download',
    method: 'GET',
    params: params
  })
}

// 添加行数据
export function addRowData (params) {
  return axios({
    url: urlPrefix + '/dataSources/row',
    method: 'POST',
    data: params
  })
}

// 修改行数据
export function editRowData (params) {
  return axios({
    url: urlPrefix + '/dataSources/row',
    method: 'PUT',
    data: params
  })
}

// 删除行数据
export function deleteRowData (params) {
  return axios({
    url: urlPrefix + '/dataSources/row',
    method: 'DELETE',
    data: params
  })
}

// 数据源列表
export function getDataSourcesList (params) {
  return axios({
    url: urlPrefix + '/dataSources/list',
    method: 'GET',
    params: params
  })
}
